import {
  FAILUREHISTORY_FETCHING,
  FAILUREHISTORY_FAILED,
  FAILUREHISTORY_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case FAILUREHISTORY_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case FAILUREHISTORY_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case FAILUREHISTORY_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
